import { render } from "./BellPendencias.vue?vue&type=template&id=4faecd0f&scoped=true"
import script from "./BellPendencias.vue?vue&type=script&lang=js"
export * from "./BellPendencias.vue?vue&type=script&lang=js"

import "./BellPendencias.vue?vue&type=style&index=0&id=4faecd0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4faecd0f"]])

export default __exports__